import { render, staticRenderFns } from "./my-safety-settings.vue?vue&type=template&id=1dc362b8&"
import script from "./my-safety-settings.vue?vue&type=script&lang=js&"
export * from "./my-safety-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports